// extracted by mini-css-extract-plugin
export default {"main_div":"Stats_main_div__IQ71y","graph_div":"Stats_graph_div__3KN5s"};